import { defineStore } from 'pinia'
import MeasurementsState, { MeasurementsStateType } from './state'
import { MeasurementsActions, MeasurementsActionsType } from './actions'
import { MeasurementsGetters } from './getters'

export const useMeasurementsStore = defineStore<
  'deviceSamples',
  MeasurementsStateType,
  typeof MeasurementsGetters,
  MeasurementsActionsType
>('deviceSamples', {
  state: MeasurementsState,
  actions: MeasurementsActions,
  getters: MeasurementsGetters,
})